module.exports = __webpack_public_path__ + "img/dsci0004.d811ec2c.jpg";